import { mapActions, mapGetters, mapMutations } from "vuex";

export const cartMethods = {
  methods: {
    ...mapActions({
      updateCart: "cart/updateCart"
    }),
    ...mapMutations({
      setCart: "cart/setCart",
      addProductToCart: "cart/addProductToCart",
      removeProductFromCart: "cart/removeProductFromCart"
    })
  },
  computed: {
    ...mapGetters({
      cart: "cart/getCart",
      products: "cart/getProductsInCart",
      isProductInCart: "cart/isProductInCart",
      getCountedProducts: "cart/getCountedProducts",
      getCountedSortedProducts: "cart/getCountedSortedProducts",
      getProductsGroupedByStore: "cart/getProductsGroupedByStore"
    })
  }
};
